import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';

const SelectBatch = ({
  setDisable,
  courses,
  setTestData,
  testData,
  loadingCourses,
}) => {
  const [errors, setErrors] = useState([]);
  const { state } = useContext(AuthContext);
  const [batches, setBatches] = useState([]);

  const handleCourseChange = (event) => {
    const courseId = event.target.value;
    const selectedCourse = courses.find(
      (course) => course.courseId === courseId
    );
    setBatches(selectedCourse?.batches || []);
    setTestData((prevTestData) => ({
      ...prevTestData,
      courseId: selectedCourse?.courseId || '',
      courseName: selectedCourse ? selectedCourse.courseName : '',
      assignedTo: [],
    }));
  };

  useEffect(() => {
    const newErrors = [];
    if (!testData?.courseId) {
      newErrors.push('Please select a course');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [setDisable, testData]);

  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={testData?.courseId || ''}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : courses.length === 0 ? (
              <option className="cursor-pointer font-bold text-brand-500">
                No courses available
              </option>
            ) : (
              courses.map((course, i) => (
                <option key={course.courseId} value={course.courseId}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>
      </div>

      {errors.length > 0 && (
        <div className="mt-2 text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectBatch;
